export default __webpack_public_path__ + "static/media/Цинк_20л-removebg-preview.391c8785.png";